import React from 'react';
import { Content } from './components/Content/Content';
import { Container, Separator } from './ListJobProfile.styles';
import Helmed from '../../icons/helmed.png';
import ExposureArea from '../../icons/jobPosition.png';
import { useListJobProfile } from './ListJobProfile.hooks';
import { JobProfileType } from 'Views/JobProfile/JobProfile.enums';
import { ErrorInfo } from 'App/Components/ErrorInfo/ErrorInfo';
import { ModalNotAuthorized } from 'App/Components/ModalNotAuthorized/ModalNotAuthorized';
import File from 'App/assets/img/job-profile-blue.svg?url';

export const ListJobProfile = () => {
	const {
		risksProfile,
		expositionAreas,
		isLoading,
		hasError,
		showModalJobProfileNotAuthorized,
		handleCloseModalJobProfileNotAuthorized,
		handleNewJobProfile,
		handleEditJobProfile,
	} = useListJobProfile();

	return (
		<Container>
			{hasError ? (
				<ErrorInfo />
			) : (
				<>
					<Content
						jobProfileType={JobProfileType.RISK_PROFILE}
						icon={Helmed}
						title="Perfiles de riesgo"
						subTitle="Factores de riesgo presentes en el proceso productivo"
						description="Identificación y análisis de la exposición a los factores de riesgo con motivo de la actividad laboral."
						items={risksProfile}
						isLoading={isLoading}
						handleNewJobProfile={handleNewJobProfile}
						handleEditJobProfile={handleEditJobProfile}
					/>
					<Separator />
					<Content
						jobProfileType={JobProfileType.EXPOSITION_AREA}
						icon={ExposureArea}
						title="Areas de exposición"
						subTitle="Factores de riesgo presentes en el espacio de trabajo"
						description="Identificación y análisis de la exposición a los factores de riesgo con motivo del espacio de trabajo."
						items={expositionAreas}
						isLoading={isLoading}
						handleNewJobProfile={handleNewJobProfile}
						handleEditJobProfile={handleEditJobProfile}
					/>
					{showModalJobProfileNotAuthorized && (
						<ModalNotAuthorized
							imageUrl={File}
							title="Perfiles de puesto"
							message="Evalua los perfiles de riesgo en tu empresa"
							onClose={handleCloseModalJobProfileNotAuthorized}
						/>
					)}
				</>
			)}
		</Container>
	);
};
